import http from "@/api";
import { useRoute } from 'vue-router';

const state = {
    endpoints: {
        // Config & Trad
        config: '/api/config/full/',
        tr_: '/api/nationality/full/',
        // User profile & create & invitation, Check email & phone
        create: '/api/user/',
        profile: '/api/user/profile/',
        invitation: '/api/user/invitation/',
        emailcheck: '/api/user/check/email/',
        phonecheck: '/api/user/check/phone/',
        // Tenants & Invitation
        tenants_invitation: '/api/tenant/invitation/',
        tenants: '/api/tenant/',
    },
    // Config & Trad
    config_: {},
    tr_: {},
    isTranslateLoad: false,
    isConfigLoad: false,

    // User profile
    profile: {},

    // Tenants & Invitation
    listTenant: [],
    currentTenant: {},

    // Session
    sessionAuthenticated: false,
}

const mutations = {
    // Config & Trad
    ['SET_TR_'](state, tr_) {
        state.tr_ = tr_;
        state.isTranslateLoad = true;
    },
    ['SET_CONFIG'](state, config) {
        state.config_ = config;
        state.isConfigLoad = true;
    },

    // User profile
    ['SET_PROFILE'](state, profile) {
        state.profile = profile;
        localStorage.setItem('profile', profile);
    },

    // Tenants & Invitation
    ['SET_LIST_TENANT'](state, list){
        state.listTenant = list;
    },
    ['SET_CURRENT_TENANT'](state, tenant) {
        state.currentTenant = tenant;
    },

    // Session
    ["SET_SESSION_AUTHENTICATED"](state){
        state.sessionAuthenticated = true;
    },
}

const getters = {
    // Check if authenticate
    isAuthenticated: state => state.sessionAuthenticated,
    // Get Tenant by UID/Group/Siren/RNA
    getTenantByUID: (state) => (uid) => {
        return state.listTenant.find(t => t.uid === uid);
    },
    getTenantsNotUID: (state) => (uid) => {
        return state.listTenant.filter(t => t.uid != uid);
    },
    getTenantByGroup: (state) => (uid) => {
        return state.listTenant.find(t => t.group.uid === uid);
    },
    getTenantByNamed: (state) => (named_id) => {
        return state.listTenant.find(t => t.group.named_id === named_id);
    },
    getTenantBySiren: (state) => (siren) => {
        return state.listTenant.find(t => t.group.siren === siren);
    },
    getTenantByRNA: (state) => (rna) => {
        return state.listTenant.find(t => t.group.rna === rna);
    },
    // Get tenant company folder
    getTenantFolder: state => {
        return state.currentTenant.group.folder.id
    },
    // Check if current tenant has role
    hasRole: (state) => (name) => {
        const roles = window.OCT_ROLES || state.currentTenant.roles;
        if (!roles) return false;
        return (roles.findIndex(role => role.name === name) > -1);
    },
    hasRoleUid: (state) => (uid) => {
        const roles = window.OCT_ROLES || state.currentTenant.roles;
        if (!roles) return false;
        return (roles.findIndex(role => role.uid === uid) > -1);
    },
    apiGroup: () => {
        const gnid = window.OCT_GROUP_NAMED_ID || useRoute().params.groupUid;
        return "/api/" + gnid;
    },

    getSentryReplay: (state) => {
        return state.profile.sentry_replay;
    },

    getUsername: (state) => {
        return state.profile.username;
    },

    getRelease: (state) => {
        return state.config_.release;
    },
}

const actions = {
    // Config & Trad
    async getConfig({ state }){
        const response = await http.get(state.endpoints.config);
        return response;
    },
    async setConfig({ dispatch, commit }){
        const response = await dispatch("getConfig");
        commit('SET_CONFIG', response.data);
        return response;
    },
    async getTranslate({ state }){
        var language = navigator.language.split('-')[1];
        language = language == 'en' ? 'us' : language;
        if(state.profile.language_pref) language = state.profile.language_pref;
        const response = await http.get(state.endpoints.tr_, {params: {lang: language}});
        return response;
    },
    async setTranslate({ dispatch, commit }){
        const response = await dispatch("getTranslate");
        commit('SET_TR_', response.data);
        return response;
    },

    async logout() {
        window.location.href = '/logout/';
    },

    // User profile & create & invitation
    async setProfile({ commit, state }){
        const response = await http.get(state.endpoints.profile);
        commit('SET_PROFILE', response.data);
        return response;
    },
    async changeLanguage({ commit, state, dispatch }, lang) {
        const response = await http.get(state.endpoints.profile, {params: {lang: lang}});
        commit('SET_PROFILE', response.data);
        dispatch('tr_');
        return response;
    },
    async createUser({ state }, payload) {
        const response = await http.post(state.endpoints.create, payload);
        return response;
    },
    async emailCheck({ state }, email){
        const response = await http.get(state.endpoints.emailcheck, {params: {check: email}});
        return response;
    },
    async phoneCheck({ state }, phone){
        const response = await http.get(state.endpoints.phonecheck, {params: {check: phone}});
        return response;
    },

    // Tenants & Invitation
    choiceTenant({ dispatch }, uid) { return dispatch('setCurrentTenant', uid); },
    choiceTenantNamed({ dispatch, getters }, named) {
        const tenant = getters.getTenantByNamed(named);
        if(tenant) return dispatch('setCurrentTenant', tenant.uid);
    },
    async setCurrentTenant({ commit, state, getters }, uid){
        if(uid) {
            const response = await http.get(state.endpoints.tenants + uid + '/current/');
            commit('SET_CURRENT_TENANT', response.data);
            return response;
        }
        if(state.listTenant.length){
            if(state.profile && state.profile.current_tenant)
                commit('SET_CURRENT_TENANT', getters.getTenantByUID(state.profile.current_tenant));
            else
                commit('SET_CURRENT_TENANT', state.listTenant[0]);
            return state.currentTenant;
        }
    },
    async setListTenant({ commit, state }, payload){
        payload = payload !== undefined ? payload : {};
        const response = await http.get(state.endpoints.tenants, payload);
        if(response.data.length){
            commit('SET_LIST_TENANT', response.data);
            //dispatch('choiceTenant');
        }
        return response;
    },

    // WS
    async getSesame({ state }) {
        const response = await http.get(state.endpoints.tenants + state.currentTenant.uid + '/current/sesame');
        return response.data.token;
    },

    // New Login Session based
    async verifySession({ commit }) {
        try {
            const response = await http.get('/session/');

            if (response.status === 200) {
                commit('SET_SESSION_AUTHENTICATED', true);
            } else {
                commit('SET_SESSION_AUTHENTICATED', false);
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                commit('SET_SESSION_AUTHENTICATED', false);
                throw new Error('SessionNotAuthenticated');
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}

